import { useState } from "react";
import { buildWhatsappLink, WHATSAPP_DEFAULT_MESSAGE } from "../lib/data";

const WhatsappIcon = ({ size = 28 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="white">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-1.746-.873-2.888-1.56-4.036-3.54-.305-.524.305-.487.873-1.62.098-.198.049-.371-.05-.52-.099-.148-.669-1.611-.916-2.16-.242-.53-.487-.457-.67-.467-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.056 3.145 4.983 4.29 2.927 1.144 2.927.763 3.874.714.947-.05 3.057-1.245 3.487-2.446.43-1.2.43-2.223.297-2.437-.13-.198-.297-.297-.594-.446z" />
    <path d="M12.014 2.003C6.492 2.003 2 6.494 2 12.017c0 1.958.55 3.784 1.502 5.34L2 22l4.783-1.462a9.96 9.96 0 0 0 5.23 1.45h.001c5.523 0 10.014-4.492 10.014-10.015 0-5.522-4.49-9.98-10.014-9.97zm5.88 14.11c-.663 1.284-2.502 2.407-3.475 2.5-.973.093-1.973.454-6.664-1.593-4.69-2.047-6.234-6.42-6.234-6.42-.262-.353-1.71-2.13-1.71-4.28 0-2.148 1.13-3.216 1.535-3.65.404-.435.884-.544 1.178-.544h.842c.27 0 .636-.05.994.766.372.85 1.267 3.126 1.38 3.353.114.227.19.494.038.792-.15.297-.226.48-.443.74-.219.26-.46.583-.657.783-.227.227-.464.472-.2.94.264.47 1.174 2.024 2.523 3.28 1.732 1.612 3.213 2.11 3.705 2.35.492.24.78.202 1.067-.135.288-.335 1.234-1.435 1.564-1.928.33-.492.66-.41 1.113-.245.454.166 2.86 1.35 3.35 1.596.49.246.816.369.936.573.12.204.12 1.183-.542 2.467z" />
  </svg>
);

export const FloatingWhatsapp = () => {
  const [hover, setHover] = useState(false);

  return (
    <a
      href={buildWhatsappLink(WHATSAPP_DEFAULT_MESSAGE)}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      data-testid="floating-whatsapp-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 flex items-center justify-center h-14 w-14 rounded-full bg-whatsapp shadow-[0_4px_24px_-4px_rgba(37,211,102,0.7)] hover:scale-105 active:scale-95 transition-transform duration-200"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-whatsapp opacity-40 animate-pulseglow" />
      <WhatsappIcon size={28} />
      <span
        className={`absolute right-full mr-3 whitespace-nowrap rounded-lg bg-card-dark border border-border-subtle px-3 py-1.5 text-xs text-white transition-all duration-200 ${
          hover ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2 pointer-events-none"
        }`}
      >
        Discuss Your Project
      </span>
    </a>
  );
};
